<template>
  <div class="wt2-sg wt2-masthead-home-icon" v-once @click="goToHome">
    <i class="wticon wticon-logo-icon"></i>
  </div>
</template>

<script>
import app from 'app';

export default app.Vue.extend({
  name: 'MastheadHomeIcon',
  methods: {
    goToHome() {
      app.state.enableNavigation();
      if ('dashboard/home' === app.rootStore.getters.routePath) {
        // already at home - refresh results
        app.rootStore.dispatch('fetchHomeStories');
        app.rootStore.dispatch('fetchHomeStoryboards');
      } else if (/dashboard\//.test(app.rootStore.getters.routePath)) {
        // already at dashboard - go home already
        this.$store.dispatch('navigate', 'dashboard/home');
      } else {
        // other routes - use common "back to dashboard' logic
        app.navigateToDashboard();
      }
    },
  },
});
</script>
